import React, { useState } from 'react';
import { useAuth } from '../../../../../../../context/AuthContext';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2'
import { useNavigate } from "react-router-dom";
import GeneralRequestHelper from '../../../../../../../Helpers/GeneralRequestHelper';
import SubmitButton from '../UI/SubmitButton';
import InfoInput from '../UI/InfoInput';
import CorrectAnswer from '../UI/CorrectAnswer';
import QuestionTextInput from '../UI/QuestionTextInput';
import AddContentQuestion from '../UI/AddContentQuestion';
import Tag from '../UI/Tag';
import TitleArea from '../UI/TitleArea';
import AnswerFormMatch from '../UI/AnswerFormMatch';

const Match = (props) => {
    const { user } = useAuth();
    const params = useParams()
    const navigate = useNavigate();
    const [msg, setMsg] = useState([]);
    const [imagePath, setImagePath] = useState(null);
    const [videoPath, setVideoPath] = useState(null);
    const [soundPath, setSoundPath] = useState(null);
    const [serviceList, setServiceList] = useState([{ service: "" }]);


    const handletype3 = async (e) => {
        e.preventDefault();
        if (document.getElementById("tagId").value === "Tür Seçiniz") {
            alert("Tür Seçmediniz.")
            return false;
        }
        var answer = document.getElementById("correctAnswer").value;
        var detailAnswer = [];

        const rawInput = document.getElementById("correctAnswer").value.trim();
        let parsedArray;
        if (rawInput.includes(" ")) {
            parsedArray = rawInput.split(/\s+/); // kelime bazlı
        } else {
            parsedArray = rawInput.split(""); // harf bazlı
        }

        for (let i = parsedArray.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [parsedArray[i], parsedArray[j]] = [parsedArray[j], parsedArray[i]];
        }

        for (let i = 0; i < parsedArray.length; i++) {
            let answerItem = {
                id: i,
                service: parsedArray[i],
            };
            detailAnswer.push(answerItem);
        }

        var splittedanswerjs = JSON.stringify(detailAnswer);


        var question;
        let questiontext = document.getElementById("questionText").value.trim() || " ";

        if (imagePath && soundPath) {
            question = {
                type: "image_sound", // İstediğin yeni tip
                url: imagePath,      // Resim URL'i
                soundUrl: soundPath, // Ses URL'i (API'nin karşılaması için yeni alan)
                text: questiontext
            };
        }
        else if (imagePath) {
            question = {
                type: "image",
                url: imagePath,
                text: questiontext
            };
        }
        else if (soundPath) {
            question = {
                type: "sound",
                url: soundPath,
                text: questiontext
            };
        }
        else if (videoPath) {
            question = {
                type: "video",
                url: videoPath,
                text: questiontext
            };
        }
        else {
            question = {
                type: "text",
                url: "",
                text: questiontext
            };
        }
        var stringquestion = JSON.stringify(question)

        var info = document.getElementById("infoBoxText").value;

        try {
            const data = {
                isDeleted: false,
                tagId: document.getElementById("tagId").value,
                sortId: params["sort"],
                contentType: "match",
                subjectId: params["subject"],
                contentStr: stringquestion,
                detail: splittedanswerjs,
                notfyText: info,
                answer: answer
            };
            await GeneralRequestHelper("/api/admin/ContentManager/Create", "post", data, user.token).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        Swal.fire({
                            title: "Başırılı!",
                            icon: "success",
                            confirmButtonText: `Soru ekleme sayfasına Dön`,
                            showDenyButton: true,
                            denyButtonText: `Aynı konuya bir soru daha ekle`,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate("/admin/createquestion");
                            } else if (result.isDenied) {
                                navigate("/admin/createquestionbysubject/" + params["subject"]);
                            }
                        });
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            alert(err.message)
            setMsg(err.message);
        }
    }

    return (
        <div>
            <TitleArea msg={msg} text={"UNSCREABLE - harflerden kelime/kelimelerden cümle"} />
            <Tag />
            <AddContentQuestion
                setMsg={setMsg}
                setImagePath={setImagePath}
                setVideoPath={setVideoPath}
                setSoundPath={setSoundPath}
                imagePath={imagePath}   // Eklendi
                videoPath={videoPath}   // Eklendi
                soundPath={soundPath}   // Eklendi
            />
            <hr />
            <form onSubmit={handletype3} >
                <QuestionTextInput />
                <CorrectAnswer text="Lütfen büyük harfler ile yazınız. Kelimeyi veya cümleyi olduğu gibi yazınız! Sistem otomatik olarak parçalayıp cevapları oluşturacaktır. " />
                <InfoInput />
                <SubmitButton />
            </form>
            <hr />
        </div>
    );
};

export default Match;